<template>
  <div class="row">
    <div class="flex xs10 offset--xs1">
      <va-card :title="title">
        <div class="row">
          <div class='flex md12 sm6 xs12'>
            <va-input
              v-model='insertData.id'
              v-show="showId"
              label='id'
              disabled
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.name"
              label="标签名称"
              removable
              :messages="message"
              :error="!!error.nameErrors.length"
              :error-messages="error.nameErrors"
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.nameEn"
              label="标签名称(英文)"
              removable
              :messages="message"
              :error="!!error.nameEnErrors.length"
              :error-messages="error.nameEnErrors"
              success
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-select
              label="标签类型"
              v-model="insertData.tagType"
              single
              :options="tagTypes.map(x => {return x.TEXT})"
              messages="必选"
              :error="!!error.tagTypeErrors.length"
              :error-messages="error.tagTypeErrors"
            />
          </div>
          <div class="flex md6 sm6 xs12">
            <va-input
              v-model="insertData.sortNum"
              label="排序"
              placeholder="数字越大越靠前"
              removable
              type="number"
              oninput="if(value <0)value=1"
              :min="1"
              :messages="message"
              :error="!!error.sortNumErrors.length"
              :error-messages="error.sortNumErrors"
            />
          </div>
        </div>
        <div class="flex md2 offset--md5">
          <va-button class="ma-0" color="primary" slot="trigger" @click="clickSubmit" :disabled="!submitButtonStatus">
            submit
          </va-button>
        </div>
      </va-card>
    </div>
  </div>
</template>

<script>

import 'vue-trix'
import { copyObject } from '../../utils/common'
import tagApi from '../../api/tag'
import { TAG_TYPES } from '../../utils/constants'

export default {
  data () {
    return {
      insertData: {
        id: null,
        name: '',
        nameEn: '',
        tagType: null,
        sortNum: 1,
      },
      message: ['Required field'],
      error: {
        nameErrors: [],
        nameEnErrors: [],
        sortNumErrors: [],
        tagTypeErrors: [],
      },
      showId: false,
      title: '创建标签',
      submitButtonStatus: true,
      tagTypes: TAG_TYPES,
    }
  },
  created () {
    this.getTag()
  },
  computed: {
    formReady () {
      return !this.error.nameErrors.length &&
          !this.error.nameEnErrors.length &&
          !this.error.sortNumErrors.length &&
          !this.error.tagTypeErrors.length
    },
  },
  methods: {
    getTag () {
      const params = this.$route.params
      if (params.id != null) {
        this.showId = true
        this.title = '编辑标签'
        // 通过id获取详情
        tagApi.getTag(params.id).then(response => {
          copyObject(response.tag, this.insertData)
          this.tagTypes.forEach(x => {
            if (x.CODE === response.tag.tagType) {
              this.insertData.tagType = x.TEXT
            }
          })
        }).catch(error => {
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
    clickSubmit () {
      this.checkField()
      if (!this.formReady) {
        return
      }
      this.changeButtonStatus(false)
      const data = {
        name: this.insertData.name,
        nameEn: this.insertData.nameEn,
        tagType: null,
        sortNum: this.insertData.sortNum !== null ? this.insertData.sortNum : 1,
      }
      this.tagTypes.map(x => {
        if (x.TEXT === this.insertData.tagType) {
          data.tagType = x.CODE
        }
      })
      if (this.insertData.id != null) {
        data.id = this.insertData.id
        tagApi.updateTag(data.id, data).then(response => {
          if (response.success === true) {
            this.showToast('标签更新成功', {
              duration: 1000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.$router.push({ name: 'listTag' })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      } else {
        tagApi.saveTag(data).then(response => {
          if (response.success === true) {
            this.showToast('添加标签成功', {
              duration: 1000,
              icon: 'fa-check',
              position: 'top-center',
              fullWidth: false,
            })
            this.$router.push({ name: 'listTag' })
          }
        }).catch(error => {
          this.changeButtonStatus(true)
          this.showToast(error.msg, {
            duration: 1000,
            icon: 'fa-warning',
            position: 'top-center',
            fullWidth: false,
          })
        })
      }
    },
    clickCancel () {
    },
    checkField () {
      this.error.nameErrors = this.insertData.name ? [] : ['name is required']
      this.error.nameEnErrors = this.insertData.nameEn ? [] : ['nameEn is required']
      this.error.sortNumErrors = this.insertData.sortNum ? [] : ['sortNum is required']
      this.error.tagTypeErrors = this.insertData.tagType ? [] : ['tagType is required']
    },
    changeButtonStatus (status) {
      this.submitButtonStatus = status
    },
  },
}

</script>

<style>
.va-card-image {
  height: 200px;
  width: 200px;
  border-radius: 5%;
  margin-bottom: 10px;
}
</style>
